<template>
  <cxl-vbden-common
    :isOpen="isOpen"
    :quote="quote"
    :flowId="flowId"
    :nextVbIncomingProcess="existedVbIncomingProcesses"
    :defaultProcessType="PROCESS_TYPE.CHUTRI"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    @submit="submit"
    ref="cxlDialog"
  />
</template>
<script>

  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import buildShortNameFilter from '../../../filters/buildShortNameFilter.js';
  import constants from '../../../constants';
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import displayDepartmentTreeMixin from "../../../mixins/displayDepartmentTreeMixin";
  import vbIncomingProcessService from "../../../services/vbIncomingProcessService";
  import vbFlowInstanceService from "../../../services/vbFlowInstanceService.js";
  import CxlVbdenCommon from "./cxl-vbden-common";

  export default {

    name: "cxl-vbden-bosung-vanthu-dialog",

    mixins: [handleRequestErrorMixin, displayDepartmentTreeMixin],
    filters: {buildShortNameFilter},
    props: ["isOpen", "docId", "quote"],
    components: {
      CxlVbdenCommon,
      dialogTemplate: () => import('../../common/custom-dialog.vue'),
      VuePerfectScrollbar
    },

    data() {
      return {
        existedVbIncomingProcesses: [],
        flowInstance: null,
        PROCESS_TYPE: constants.PROCESS_TYPE
      }
    },

    computed: {
      flowId() {
        return this.flowInstance ? this.flowInstance.flowId : null;
      },
      flowInstanceId() {
        return this.flowInstance ? this.flowInstance.id : null;
      }
    },

    mounted() {
      this.loadFlowInstance()
        .then(() => this.loadProcessDaCxl())
        .then(() => this.$refs.cxlDialog.initForm());
    },

    methods: {
      loadFlowInstance() {
        return vbFlowInstanceService
          .findAll(
            {docId: this.docId},
            {page: 0, size: 1, sort: "updateTime,desc"}
          )
          .then(response => this.flowInstance = response.data[0]);
      },

      loadProcessDaCxl() {
        return vbIncomingProcessService
          .firstVbIncomingProcesses(this.docId)
          .then(response => this.existedVbIncomingProcesses = response.data);
      },

      submit(event) {
        let processHandlerForms = event.handlersData
          .filter(item => item.stepType === constants.STEP.STEP_TYPE.CANHAN)
          .map(item => {
            let userDeptRole = item.userDeptRole;
            return {
              userId: userDeptRole.userId,
              deptId: userDeptRole.deptId,
              roleId: userDeptRole.roleId,
              positionId: userDeptRole.positionId,
              userDeptRoleId: userDeptRole.id,
              processType: item.processType,
              stepId: item.stepId
            };
          });

        let processHandlerDeptForms = event.handlersData
          .filter(item => item.stepType === constants.STEP.STEP_TYPE.DONVI)
          .map(item => {
            return {
              deptId: item.department.id,
              stepId: item.stepId,
              processType: item.processType,
            };
          });

        let submitForm = {
          flowInstanceId: this.flowInstanceId,
          flowId: this.flowId,
          content: event.note,
          processHandlerForms: processHandlerForms,
          processHandlerDeptForms: processHandlerDeptForms
        };

        vbIncomingProcessService
          .chuyenXuLiVanThuBoSung(submitForm, this.docId)
          .then((response) => {
            this.$message({message: 'Chuyển xử lý văn bản đến thành công', type: 'success'});
            this.$emit("cxlBoSungSuccess", {vbIncomingProcesses: response.data});
          })
          .catch(error => this.commonHandleRequestError(error))

      },
    },
  }
</script>
<style scoped>
  .title {
    width: 100%;
  }

  .list-checkbox {
    position: relative;
    margin-right: 25px;
  }

  .scroll-list-user {
    height: auto;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    padding-right: 3px;
  }

  .list-checkbox .item {
    width: 100px;
    text-align: center;
    margin: 0;
  }

  .icon-close {
    position: absolute;
    right: -5px;
    font-size: 18px;
  }

  .dialog-body .display-list__selected .list-selected .header > div {
    width: 100%;
  }

  .dialog-body .display-list__selected .list-selected .body {
    padding: 0;
  }

  .dialogTransferHandling .dialog-body .scroll-area-height_90 {
    height: 70%;
  }

  .dialog-body .display-list__selected {
    height: 400px;
  }

  .dialogTransferHandling .dialog-body .display-list__selected .list-selected {
    height: calc(100% - 121px);
  }

  .dialog-body .display-list__selected .list-selected .header {
    padding-left: 10px;
    padding-right: 10px;
  }

  .dialog-body .display-list__selected .list-selected .body .list-filter {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/cxl-vbden-bosung-vanthu-dialog.vue